module.exports = __webpack_public_path__ + "static/media/Figure Skating Champion.7997d0ff.jpg";